<div #stickyPanel
     class="td-wb-sticky-observer__panel"
     [ngStyle]="{ 'top': getTop() }"></div>
